// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V187T","content":"styles_content__2wLzc"};